import React, { useEffect, useState } from "react";
import { Button, Form, Spin, Modal, Popconfirm, Dropdown, Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { PAGE_SIZE } from "../../../constants";
import { Link } from "react-router-dom";
import SpinTheWheelRewardsTable from "../../Tables/SpinTheWheelRewards";
import {
	createSpinReward,
	deleteSpinReward,
	fetchSpinRewards,
	resetDeleteStatusSpinReward,
	updateSpinReward,
} from "../../../actions/spinTheWheelReward";
import { ReactSVG } from "react-svg";
import SpinRewardForm from "../../Forms/SpinTheWheelReward";
import moment from "moment";

const SpinTheWheelRewardsPage = () => {
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const { spinRewards, loading } = useSelector(
		(state) => state.fetchSpinRewards,
	);
	const { spinRewardDeleted } = useSelector((state) => state.deleteSpinReward);
	const { status: updateStatus } = useSelector(
		(state) => state.updateSpinReward,
	);
	const [currentPage, setCurrentPage] = useState(1);
	const [pagination, setPagination] = useState({});
	const [spinRewardId, setSpinRewardId] = useState(null);
	const limit = Number(PAGE_SIZE) || 20;
	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
		form.resetFields();
		setSpinRewardId(null);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		form.resetFields();
		setSpinRewardId(null);
	};

	const handleEdit = (record) => {
		showModal();
		setSpinRewardId(record.id);
		form.setFieldsValue({
			...record,
			start_date: moment(record.start_date).utcOffset("+08:00"),
			end_date: moment(record.end_date).utcOffset("+08:00"),
		});
	};

	const handleClickDelete = (record) => {
		dispatch(deleteSpinReward(record.id));
	};

	const addNewRewardClick = () => {
		showModal();
		form.resetFields();
	};

	const handleSubmitForm = (values) => {
		const newValues = values;
		newValues.start_date = values.start_date
			? moment(values.start_date).format("DD/MM/YYYY")
			: null;
		newValues.end_date = values.end_date
			? moment(values.end_date).format("DD/MM/YYYY")
			: null;

		if (spinRewardId) {
			dispatch(updateSpinReward(spinRewardId, newValues));
		} else {
			dispatch(createSpinReward(newValues));
		}
		handleOk();
	};

	const handleFilter = (params) => {
		setCurrentPage(params.page);
		const startAt = (params.page - 1) * Number(PAGE_SIZE);
		dispatch(fetchSpinRewards({ start: Number(startAt), count: PAGE_SIZE }));
	};

	const handleTableChange = (params) => {
		handleFilter(params);
	};

	useEffect(() => {
		if (spinRewardDeleted) {
			dispatch(fetchSpinRewards({ start: 0, count: PAGE_SIZE }));
			dispatch(resetDeleteStatusSpinReward());
		}
	}, [spinRewardDeleted]);

	useEffect(() => {
		if (updateStatus === "SUCCEEDED")
			dispatch(fetchSpinRewards({ start: 0, count: PAGE_SIZE }));
	}, [updateStatus]);

	useEffect(() => {
		if (spinRewards) {
			setPagination({
				showSizeChanger: false,
				current: currentPage,
				pageSize: limit,
				total: spinRewards.data.total,
				showTotal: (total) => `${total} Items`,
			});
		}
	}, [spinRewards]);

	useEffect(() => {
		dispatch(fetchSpinRewards({ start: 0, count: PAGE_SIZE }));
	}, []);

	const withAction = (record) => {
		return (
			<span className="action" style={{ display: "flex" }}>
				<Dropdown.Button overlay={() => tableActionMenu(record)} />
			</span>
		);
	};

	const tableActionMenu = (record) => (
		<Menu className="table-action-menu">
			<Menu.Item key="view">
				<Link to={`/spin-the-wheel/rewards/${record?.id}`}>
					<Button className="btn-table-action-primary" type="link">
						Show
					</Button>
				</Link>
			</Menu.Item>
			<Menu.Item key="edit">
				<Button
					className="btn-table-action-primary"
					type="link"
					onClick={() => handleEdit(record)}
				>
					Edit
				</Button>
			</Menu.Item>
			<Menu.Item key="delete">
				<Popconfirm
					title="Are you sure to delete this one?"
					onConfirm={() => handleClickDelete(record)}
					okText="Yes"
					cancelText="No"
				>
					<Button type="link" className="btn-table-action-danger">
						Delete
					</Button>
				</Popconfirm>
			</Menu.Item>
		</Menu>
	);

	return (
		<Spin spinning={loading} tip="Loading ...">
			<div className="spin-the-wheel-rates-container">
				<div className="page-header">
					<div className="page-header-breadbrumb">
						<ul>
							<li>Rewards</li>
						</ul>
					</div>
					<div>
						<Button
							type="primary"
							className="btn btn-primary"
							onClick={addNewRewardClick}
						>
							New Reward
							<ReactSVG src="/icons/post-add.svg" />
						</Button>
					</div>
				</div>
				<div className="page-content">
					{spinRewards && (
						<SpinTheWheelRewardsTable
							rowKey="id"
							dataSource={spinRewards.data.data}
							pagination={pagination}
							onChange2={handleTableChange}
							scrollHeight="calc(100vh - 275px)"
							actionWidth={50}
							withAction={withAction}
						/>
					)}
				</div>
				<Modal
					className="spin-form-modal"
					visible={isModalVisible}
					onOk={handleOk}
					onCancel={handleCancel}
					footer={null}
				>
					{spinRewards && (
						<SpinRewardForm
							form={form}
							spinRewardId={spinRewardId}
							handleOk={handleOk}
							handleSubmitForm={handleSubmitForm}
							handleCancel={handleCancel}
						/>
					)}
				</Modal>
			</div>
		</Spin>
	);
};

export default SpinTheWheelRewardsPage;
